import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* clearPublicChatSaga() {
  yield call(SignalingSocket.send, { event: 'clearPublicChat', data: {} });
}
